import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

/**
 * Sanitizes raw provider/backend error payloads before showing them in the UI.
 */
export const sanitizePropertyPublicationErrorMessage = (
  value: unknown
): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  if (trimmedValue.length === 0) {
    return null;
  }

  if (
    (trimmedValue.startsWith('[') && trimmedValue.endsWith(']')) ||
    (trimmedValue.startsWith('{') && trimmedValue.endsWith('}'))
  ) {
    return null;
  }

  return trimmedValue;
};

const publicationProblemKeyByCode: Record<string, TranslationKey> = {
  missing_remote_listing:
    'catalog.properties.publicationProblems.missingRemoteListing',
};

const publicationProblemKeyByMessage: Record<string, TranslationKey> = {
  'The listing is no longer present in the remote seller inventory.':
    'catalog.properties.publicationProblems.missingRemoteListing',
};

export const resolvePropertyPublicationProblemMessage = ({
  code,
  message,
  t,
}: {
  code: unknown;
  message: unknown;
  t: (key: TranslationKey) => string;
}): string | null => {
  const sanitizedMessage = sanitizePropertyPublicationErrorMessage(message);

  if (typeof code === 'string') {
    const mappedKey = publicationProblemKeyByCode[code];
    if (mappedKey) {
      return t(mappedKey);
    }
  }

  if (sanitizedMessage) {
    const mappedKey = publicationProblemKeyByMessage[sanitizedMessage];
    if (mappedKey) {
      return t(mappedKey);
    }
  }

  return sanitizedMessage;
};
